// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Es6Promise from 'es6-promise';
import Vue from 'vue'
import App from './App'
import VueLazyload from 'vue-lazyload'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import BaiduMap from 'vue-baidu-map'
// import vConsole from '@/request/vconsole.js'

import Router from 'vue-router'
Es6Promise.polyfill();
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
// Vue.use(vConsole)
// Vue.use(BaiduMap, {
//     ak: 'pCaC264mc4eyWqAluOz5qNKrdt0sdWse'
// })
Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1
})

Vue.use(ElementUI)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.config.productionTip = false
Vue.config.devtools = true
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    render: h => h(App)
}).$mount("#app")